<template>
  <div class="hero-section wf-section">
    <div class="timeslot-container">
      <div
        data-collapse="medium"
        data-animation="default"
        data-duration="400"
        data-w-id="519dbec9-6ecd-29c5-c2ca-e2acf9a27145"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        class="timeslot-navbar w-nav small"
      >
        <div class="navbar-wrapper">
          <a href="#" class="timeslot-logo w-nav-brand">
            <img
              src="@/assets/timeslot-images/timeslate-logo.svg"
              loading="lazy"
              alt=""
              class="navbar1_logo"
            />
          </a>
          <div
            @click="showNav"
            v-if="bar"
            class="meu-button w-nav-button"
            style="-webkit-user-select: text;"
            aria-label="menu"
            role="button"
            tabindex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="false"
          >
            <div class="menu-icon1">
              <div
                class="menu-icon1_line-top"
                style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              ></div>
              <div
                class="menu-icon1_line-middle"
                style="width: 24px; height: 2px;"
              >
                <div class="menu-icon_line-middle-inner"></div>
              </div>
              <div
                class="menu-icon1_line-bottom"
                style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              ></div>
            </div>
          </div>
          <div
            class="meu-button w-nav-button w--open"
            @click="closeNav"
            v-if="cross"
            style="-webkit-user-select: text;"
            aria-label="menu"
            role="button"
            tabindex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="true"
          >
            <div class="menu-icon1">
              <div
                class="menu-icon1_line-top"
                style="transform: translate3d(0px, 8px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(-45deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              ></div>
              <div
                class="menu-icon1_line-middle"
                style="width: 0px; height: 2px;"
              >
                <div class="menu-icon_line-middle-inner"></div>
              </div>
              <div
                class="menu-icon1_line-bottom"
                style="transform: translate3d(0px, -8px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(45deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              ></div>
            </div>
          </div>

          <!--            <div class="meu-button w-nav-button" style="-webkit-user-select: text;" aria-label="menu" role="button" tabindex="0" aria-controls="w-nav-overlay-0" aria-haspopup="menu" aria-expanded="false">-->
          <!--              <div class="menu-icon1">-->
          <!--                <div class="menu-icon1_line-top" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"></div>-->
          <!--                <div class="menu-icon1_line-middle" style="width: 24px; height: 2px;">-->
          <!--                  <div class="menu-icon_line-middle-inner"></div>-->
          <!--                </div>-->
          <!--                <div class="menu-icon1_line-bottom" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"></div>-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
        <div
          class="w-nav-overlay "
          data-wf-ignore=""
          id="w-nav-overlay-0"
          style="height: 100vh; display: block; background-color: white;"
          v-if="cross"
        >
          <nav
            role="navigation"
            class="navbar-menu w-nav-menu"
            style="transform: translateY(0px) translateX(0px); transition: transform 400ms ease 0s;"
            data-nav-menu-open=""
          >
            <router-link
              to="/discover-professionals"
              class="navbar1_link w-nav-link w--nav-link-open"
              >Discover</router-link
            >
            <router-link
              to="/become-a-professional"
              class="navbar1_link w-nav-link w--nav-link-open"
              >Become a Professional</router-link
            >
            <div class="navbar1_menu-buttons">
              <div class="navbar1_button-wrapper">
                <router-link to="/login" class="login-button w-button"
                  >Login</router-link
                >
              </div>
              <div class="navbar1_button-wrapper">
                <router-link to="/get-started" class="sign-up-button w-button"
                  >Get Started</router-link
                >
              </div>
            </div>
          </nav>
        </div>
      </div>
      <LandingPageNavBar />
      <header class="section-header1">
        <div class="page-padding">
          <div class="container-large">
            <div class="padding-vertical padding-xhuge">
              <div class="w-layout-grid header1_component">
                <div
                  id="w-node-_41964f9e-03c1-bacb-4b6e-10bd3818e3a6-bfc715f5"
                  class="header1_content"
                >
                  <div class="margin-bottom margin-small">
                    <div class="get-c-holder">
                      <img
                        src="@/assets/timeslot-images/avatar.png"
                        loading="lazy"
                        class="get-connected-img"
                        alt=""
                      />
                    </div>
                    <div class="get-c-text">
                      <h1 class="heading">
                        Get connected <br />to the best mentors
                      </h1>
                    </div>
                  </div>
                  <p class="text-size-medium">
                    Book and meet mentors for 1:1 consultation in our global
                    community.
                  </p>
                  <div class="margin-top margin-small">
                    <div class="button-row">
                      <div class="button-wrapper">
                        <router-link
                          to="/get-started"
                          class="sign-up-button w-button"
                          >Get Started</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="header1_image-wrapper">
                  <!--                  <img src="@/assets/timeslot-images/animation_500_l5w0sfdx.gif" loading="lazy" class="lotie"  alt="">-->
                  <!--                  <div-->
                  <!--                    class="lottie-animation"-->
                  <!--                    data-w-id="140215c7-984c-d24c-8e58-3b38dbeabc5d"-->
                  <!--                    data-animation-type="lottie"-->
                  <!--                    data-src="documents/Timeslot-Hero-Lottie-2.json"-->
                  <!--                    data-loop="1"-->
                  <!--                    data-direction="1"-->
                  <!--                    data-autoplay="1"-->
                  <!--                    data-is-ix2-target="0"-->
                  <!--                    data-renderer="svg"-->
                  <!--                    data-default-duration="20.6"-->
                  <!--                    data-duration="0"-->
                  <!--                  ></div>-->
                  <!--                  <lottie-player src="../../assets/documents/Timeslot-Hero-Lottie-2.json"  background="transparent"  speed="1"  autoplay>-->

                  <!--                  </lottie-player>-->
                  <vLottiePlayer
                    name="bookaslot-json"
                    class="lottie-animation"
                    loop
                    :animationData="
                      require('../../assets/documents/Timeslot-Hero-Lottie-2.json')
                    "
                    width="100%"
                    height="100%"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  </div>
</template>

<script>
import "@/assets/css/normalize.css";
import "@/assets/css/webflow.css";
import "@/assets/css/timeslot-dev.webflow.css";
import LandingPageNavBar from "@/views/timeslot/LandingPageNavBar";
import VueLottiePlayer from "vue-lottie-player";
export default {
  name: "TimeslotLandingPage",
  components: { LandingPageNavBar, vLottiePlayer: VueLottiePlayer },
  data() {
    return {
      bar: true,
      cross: false
    };
  },
  methods: {
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    }
  }
};
</script>

<style scoped>
.get-c-holder {
  /*background-color: #7f3737;*/
  position: relative;
  top: 50px;
  left: 400px;
  width: 25%;
}
.get-connected-img {
  /*position: relative;*/
  /*left: 70%;*/
  /*top: 100px;*/
  width: 100%;
}
.get-c-text {
  /*width: 90%;*/
}
@media only screen and (max-width: 991px) {
  .get-c-holder {
    top: 0;
    left: 0;
    width: 60%;
    text-align: center;
    margin: 0 auto;
  }
}
@media only screen and (min-width: 992px) {
  .timeslot-navbar.w-nav.small {
    display: none;
  }
}
</style>
